import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        This extension to a late-Victorian home will create a bespoke
        transition space from the house to the enclosed garden to the rear.
      </p>
      <p>
        The project will relocate the existing bathroom into the middle of
        the house, with generous spaces and high quality materials to create
        a bathroom of ‘spa quality’.
      </p>
      <p>
        A new mono-pitched extension will be created, with extensive glazing
        and rooflight to make the most of its orientation, views and access
        to the mature garden, and a sensitive relationship with the
        neighbouring properties in this constrained setting.
      </p>
      <p>
        The interior design of the spaces has used the in-house rendering
        capabilities to interrogate materials and finishes, to allow
        confidence in the final specifications, and to test sun-paths and
        expected light levels.
      </p>
      <p>
        The property is within the Ely Conservation Area
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/willow-walk-extension.jsx